import { render, staticRenderFns } from "./SeletorUnidade.vue?vue&type=template&id=366c1d46&"
import script from "./SeletorUnidade.vue?vue&type=script&lang=js&"
export * from "./SeletorUnidade.vue?vue&type=script&lang=js&"
import style0 from "./SeletorUnidade.vue?vue&type=style&index=0&id=366c1d46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports